module.exports = __webpack_public_path__ + "img/Flag_of_Latvia.9fa6c690.svg";